import { render, staticRenderFns } from "./ArticleCategoryHeader.vue?vue&type=template&id=bd62158c&"
import script from "./ArticleCategoryHeader.vue?vue&type=script&lang=js&"
export * from "./ArticleCategoryHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports